<app-list-renderer [listTemplate]="listTemplate" (onNextPage)="loadMore($event)"></app-list-renderer>
